/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown> }} Ocr_Extracting_FramesInputs */



/**
* | output |
* | --- |
* | "Extracting frames... {progress}%" |
*
* @param {Ocr_Extracting_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_extracting_frames = /** @type {((inputs: Ocr_Extracting_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Extracting_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Extraction des images... ${i?.progress}%`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Frames werden extrahiert... ${i?.progress}%`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Estrazione dei fotogrammi... ${i?.progress}%`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Извлечение кадров... ${i?.progress}%`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Extrayendo fotogramas... ${i?.progress}%`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在提取帧... ${i?.progress}%`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フレームを抽出中... ${i?.progress}%`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ़्रेम निकाले जा रहे हैं... ${i?.progress}%`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Extraindo quadros... ${i?.progress}%`)
	return /** @type {LocalizedString} */ (`Extracting frames... ${i?.progress}%`)
});